<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  data: () => ({
    time: [],
    time2: [],
    dataSet: [],
    dataSet2: [],
    resultIndoorManHour: [],
    resultIndoorTagManHour: [],
  }),
  mounted() {
    console.log('Hi from BarChart')
    this.$API.get("indoormanhour").then((result) => {
      console.log(result.data)
      result.data.result.forEach((element) => {
        this.resultIndoorManHour.push({
          date: element.date,
          id: element.id,
          target: element.target,
          username: element.username,
        });
      });
      this.resultIndoorManHour.sort(function(a, b) {
        a = a.date.split("-");
        b = b.date.split("-");
        return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
      });
      // console.log("this.resultIndoorManHour", this.resultIndoorManHour);
      this.$API.get("indoortag/manhour").then((result2) => {
      console.log(result2.data)
        this.resultIndoorTagManHour = result2.data;
        this.resultIndoorTagManHour.sort(function(a, b) {
          a = a.date.split("-");
          b = b.date.split("-");
          return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
        });
        this.resultIndoorManHour.forEach((element) => {
          this.resultIndoorTagManHour.forEach((element2) => {
            if (element.date === element2.date) {
              console.log(element2)
                this.time.push(element.date);
                this.time2.push(element2.date);
                this.dataSet.push(element.target);
                this.dataSet2.push(element2.manhour);
            }
          });
          this.renderChart(
            {
              labels: this.time,
              datasets: [
                {
                  label: "Total Manhour",
                  backgroundColor: "#4caf50",
                  data: this.dataSet2,
                },
                {
                  label: "Target Manhour",
                  backgroundColor: "grey",
                  data: this.dataSet,
                },
              ],
            },
            { responsive: true, maintainAspectRatio: false }
          );
        });
        // console.log("this.resultIndoorTagManHour", this.resultIndoorTagManHour);
      });
    });
    // console.log("this.time", this.time);
    // console.log("this.dataSet", this.dataSet);
    // console.log("this.dataSet2", this.dataSet2);

    //   this.$API.get("indoormanhour").then((result) => {
    //     let count = 0;
    //     const length = result.data.length;
    //     result.data.forEach((element) => {
    //       let subDate = element.date.substring(0, 10);
    //       count += 1;
    //       this.time2.push(subDate);
    //       this.dataSet2.push(element.target);
    //       this.time2.sort(function(a, b) {
    //         a = a.split("-");
    //         b = b.split("-");
    //         return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
    //       });
    //       if (length === count) {
    //         this.renderChart(
    //           {
    //             labels: this.time,
    //             datasets: [
    //               {
    //                 label: "Data One",
    //                 backgroundColor: "#4caf50",
    //                 data: this.dataSet,
    //               },
    //               {
    //                 label: "Data Two",
    //                 backgroundColor: "grey",
    //                 data: this.dataSet2,
    //               },
    //             ],
    //           },
    //           { responsive: true, maintainAspectRatio: false }
    //         );
    //       }
    //     });
    //   });
    //   this.$API.get("indoortag/manhour").then((result) => {
    //     let count = 0;
    //     const length = result.data.length;
    //     result.data.forEach((element) => {
    //       count += 1;
    //       if (element.manhour !== null) {
    //         this.time.push(element.date);
    //         this.dataSet.push(element.manhour);
    //         this.time.sort(function(a, b) {
    //           a = a.split("-");
    //           b = b.split("-");
    //           return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
    //         });
    //       }
    //       if (length === count) {
    //         this.renderChart(
    //           {
    //             labels: this.time,
    //             datasets: [
    //               {
    //                 label: "Data One",
    //                 backgroundColor: "#4caf50",
    //                 data: this.dataSet,
    //               },
    //               {
    //                 label: "Data Two",
    //                 backgroundColor: "grey",
    //                 data: this.dataSet2,
    //               },
    //             ],
    //           },
    //           { responsive: true, maintainAspectRatio: false }
    //         );
    //       }
    //     });
    //   });
  },
};
</script>
